var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ArgumentNullError = /** @class */ (function (_super) {
    __extends(ArgumentNullError, _super);
    function ArgumentNullError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArgumentNullError.fromName = function (name) {
        return new ArgumentNullError(name + " is required but received 'null'.");
    };
    return ArgumentNullError;
}(Error));
export { ArgumentNullError };
var InvalidParameterError = /** @class */ (function (_super) {
    __extends(InvalidParameterError, _super);
    function InvalidParameterError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvalidParameterError.fromName = function (name, reason) {
        return new InvalidParameterError("Invalid parameter " + name + ((reason && ": " + reason) || "") + ".");
    };
    InvalidParameterError.typeof = function (name, type, options) {
        return new InvalidParameterError("Invalid type for parameter " + name + ": " + (options ? " expected type '" + options.expected + "', got " + type : type));
    };
    return InvalidParameterError;
}(Error));
export { InvalidParameterError };



//////////////////
// WEBPACK FOOTER
// ../plano/dist/errors.js
// module id = 422
// module chunks = 0